import React, {useEffect, useState} from "react";
import s from "../style.module.css";
import "animate.css";

export default function Animation({isSmallScreen}) {
    const [animationClassAfterInDown, setAnimationClassAfterInDown] = useState(
        "animate__zoomInDown"
    );
    const [animationClassAfterInUp, setAnimationClassAfterInUp] =
        useState("animate__zoomInUp");
    const [animationClassAfterInLeft, setAnimationClassAfterInLeft] = useState(
        "animate__zoomInLeft"
    );
    const [animationClassAfterInDown2, setAnimationClassAfterInDown2] = useState(
        "animate__zoomInDown"
    );
    useEffect(() => {
        let timer;
        let timer2;
        let timer3;
        let timer4;
        if (!isSmallScreen) {
            timer = setTimeout(() => {
                setAnimationClassAfterInDown("animate__jello");
            }, 2300);

            timer2 = setTimeout(() => {
                setAnimationClassAfterInUp("animate__jello");
            }, 2500);

            timer3 = setTimeout(() => {
                setAnimationClassAfterInLeft("animate__jello");
            }, 2700);

            timer4 = setTimeout(() => {
                setAnimationClassAfterInDown2("animate__flip");
            }, 2900);
        }

        return () => {
            clearTimeout(timer);
            clearTimeout(timer2);
            clearTimeout(timer3);
            clearTimeout(timer4);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <div>
                <img
                    id="img1"
                    className={`${s.image} mx-1 animate__animated ${animationClassAfterInDown2}`}
                    src="assets/iconsTech/github.webp"
                    alt="angular"
                />
            </div>

            <div>
                <img
                    id="img2"
                    className={`${s.image} mx-1 animate__animated ${animationClassAfterInLeft}`}
                    src="assets/iconsTech/react.webp"
                    alt="react"
                />
            </div>

            <div>
                <img
                    id="img3"
                    className={`${s.image} mx-1 animate__animated ${animationClassAfterInUp}`}
                    src="assets/iconsTech/java.webp"
                    alt="angular"
                />
            </div>

            <div>
                <img
                    id="img4"
                    className={`${s.image} mx-1 animate__animated ${animationClassAfterInDown}`}
                    src="assets/iconsTech/spring.webp"
                    alt="angular"
                />
            </div>

            <div>
                <img
                    id="img5"
                    className={`${s.image} mx-1 animate__animated animate__rubberBand`}
                    style={{
                        animationDelay: "2s",
                    }}
                    src="assets/iconsTech/angular.webp"
                    alt="angular"
                />
            </div>

            <div>
                <img
                    id="img6"
                    className={`${s.image} mx-1 animate__animated ${animationClassAfterInDown}`}
                    src="assets/iconsTech/node.webp"
                    alt="angular"
                />
            </div>

            <div>
                <img
                    id="img7"
                    className={`${s.image} mx-1 animate__animated ${animationClassAfterInUp}`}
                    src="assets/iconsTech/docker.webp"
                    alt="angular"
                />
            </div>

            <div>
                <img
                    id="img8"
                    className={`${s.image} mx-1 animate__animated ${animationClassAfterInLeft}`}
                    src="assets/iconsTech/bootstrap.webp"
                    alt="angular"
                />
            </div>

            <div>
                <img
                    id="img9"
                    className={`${s.image} mx-1 animate__animated ${animationClassAfterInDown2}`}
                    src="assets/iconsTech/bdd.webp"
                    alt="react"
                />
            </div>
        </>
    );
}
